export class PosConfigurationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPosConfigurations() {
    return this.#http.get('/api/pos-configurations');
  }

  async getPosConfiguration({ id }) {
    return this.#http.get(`/api/pos-configurations/${id}`);
  }

  async getEnabledStepKeys({ id, signal }) {
    return this.#http.get(`/api/pos-configurations/${id}/enabled-step-keys`, { signal });
  }

  async createPosConfiguration(body) {
    return this.#http.post('/api/pos-configurations', body);
  }

  async updatePosConfiguration({ id, ...body }) {
    return this.#http.put(`/api/pos-configurations/${id}`, body);
  }

  async deletePosConfiguration({ id }) {
    return this.#http.delete(`/api/pos-configurations/${id}`);
  }

  async getPosConfigurationDomains({ id }) {
    return this.#http.get(`/api/pos-configurations/${id}/domains`);
  }

  async assignPosConfigurationDomain({ id, domainName }) {
    return this.#http.post(`/api/pos-configurations/${id}/domains`, { domainName });
  }

  async removePosConfigurationDomain({ id, domainName }) {
    return this.#http.delete(`/api/pos-configurations/${id}/domains/${domainName}`);
  }

  async setPosConfigurationDefault({ id }) {
    return this.#http.put(`/api/pos-configurations/${id}/set-default`);
  }

  async setDomainDefault({ id, domainName }) {
    return this.#http.put(`/api/pos-configurations/${id}/domains/${domainName}/set-default`);
  }

  async uploadPosConfigurationImage({ id, type, formData }) {
    return this.#http.post(`/api/pos-configurations/${id}/images/${type}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async uploadPosConfigurationDocument({ id, type, formData }) {
    return this.#http.post(`/api/pos-configurations/${id}/documents/${type}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async uploadPosConfigurationStepIcon({ stepKey, formData }) {
    return this.#http.post(`/api/pos-configurations/step-icons/${stepKey}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async getFormBundleCriteria({ id }) {
    return this.#http.get(`/api/pos-configurations/${id}/form-bundle-criteria`);
  }

  async createFormBundleCriteria({ id, body }) {
    return this.#http.post(`/api/pos-configurations/${id}/form-bundle-criteria`, body);
  }

  async updateFormBundleCriteria({ id, criteriaId, body }) {
    return this.#http.put(`/api/pos-configurations/${id}/form-bundle-criteria/${criteriaId}`, body);
  }

  async deleteFormBundleCriteria({ id, criteriaId }) {
    return this.#http.delete(`/api/pos-configurations/${id}/form-bundle-criteria/${criteriaId}`);
  }

  async savePreview(body) {
    return this.#http.post('/api/pos-configuration-previews', body);
  }
}
